import { Button } from 'antd'

type Props = {}

export default function Introduction({ }: Props) {
    return (
        <div
            style={{
                color: 'white',
                width: '100vw',
                marginBottom: '15rem',
            }}
        >
            <div style={{
                fontFamily: 'conthrax',
                textAlign: 'center',
                boxShadow: '0 0 .2rem 0 white',
                borderRadius: '1rem',
                padding: '1rem',
                width: 'fit-content',
                margin: 'auto',
                marginTop: '20vh',
                fontSize: window.innerWidth > 768 ? '2rem' : '1.5rem',
                backgroundColor: 'rgba(0, 0, 0, 0.764)',
            }}>
                Thông tin chung
            </div>
            <div
                style={{
                    fontFamily: 'Readex Pro',
                    width: window.innerWidth > 768 ? '60vw' : '80vw',
                    height: 'fit-content',
                    margin: 'auto',
                    marginTop: '2rem',
                    boxShadow: '0 0 .2rem 0 white',
                    borderRadius: '1rem',
                    padding: '1rem',
                    fontSize: window.innerWidth > 768 ? '1rem' : '.8rem',
                    color: 'rgba(220, 220, 220, 0.82)',
                    backgroundColor: 'rgba(0, 0, 0, 0.664)',
                    lineHeight: '3rem',
                }}
            >
                <li>
                    English Speaking Competition “Unlock Your Potential” là cuộc thi được tổ chức bởi Câu Lạc Bộ Kỹ Năng và Ngoại Ngữ -
                    Skillcetera trực thuộc trường Đại học FPT thành phố Hồ Chí Minh.
                    Đây là một cuộc thi tìm kiếm những nhân tố có kỹ năng, khả năng về tư duy Tiếng Anh xuất sắc.
                    Các thí sinh tham gia cuộc thi được tuyển chọn và sàng lọc kỹ càng thông qua các vòng thi của Ban Tổ Chức.
                </li>
                <li>
                    Cuộc thi English Speaking Competition “Unlock Your Potential” được tổ chức với mong muốn
                    tìm ra những gương mặt trẻ sáng giá và tài năng.
                    Đồng thời khai phá tiềm năng của các thí sinh thông qua những chia sẻ truyền cảm hứng,
                    khả năng tư duy ngôn ngữ nhạy bén và sáng tạo.
                </li>
                <li>
                    Đối tượng tham gia: Cuộc thi English Speaking Competition là sân chơi dành cho các cá nhân là sinh viên đang sinh sống
                    và học tập tại các trường đại học và cao đẳng trên toàn quốc.
                </li>
                <div style={{
                    textAlign: 'center',
                }}>
                    <Button style={{
                        background: 'linear-gradient(264.28deg, #ffc7c7 -38.2%, #fe2727 103.12%)',
                        fontFamily: 'conthrax',
                        color: 'white',
                        border: 'none',
                    }}
                        onClick={() => {
                            window.open('https://www.facebook.com/skillcetera/posts/pfbid0RrUx3VhhPNEk26FuZnE7W2TGw2Uf5eWsdoX3qpiQpohvM8RnZTRezFoxVkj4o5XLl')
                        }}
                    >Bài công bố</Button>
                </div>
            </div>

        </div>
    )
}